import {
  Accordion,
  AccordionDetails,
  Box,
  IconButton,
  ListItem,
  styled,
} from '@mui/material';

import { elevationLevel } from '@/styles/constants/paper';
import { doNotForwardTheseProps } from '@/styles/utils';

export const ListActionItemContainer = styled(ListItem)<{ disabled?: boolean }>(
  ({ theme, disabled }) => ({
    backgroundColor: disabled ? 'transparent' : theme.palette.background.paper,
    border: disabled ? `1px solid ${theme.palette.grey[200]}` : 'none',
    boxShadow: theme.shadows[elevationLevel.s],
    padding: theme.spacing(2),
    borderRadius: 12,
    opacity: disabled ? 0.3 : 1,

    ':not(:last-of-type)': {
      marginBottom: theme.spacing(1.5),
    },

    '.MuiListItemText-root': {
      flex: 1,
    },

    '.MuiListItemButton-root': {
      flexGrow: 0,
      padding: 0,

      ':hover': {
        backgroundColor: 'transparent',
      },
    },
  }),
);

export const ActionButton = styled(IconButton)(({ onClick }) => ({
  backgroundColor: 'transparent',
  padding: 0,
  minWidth: 0,
  cursor: onClick ? 'pointer' : 'default',
}));

export const StyledAccordion = styled(Accordion)(({ theme, disabled }) => ({
  opacity: disabled ? 0.38 : 1,
  border: `1px solid ${theme.palette.grey[200]}`,
  '&.Mui-disabled': {
    backgroundColor: disabled ? 'transparent' : theme.palette.background.paper,
    '.MuiAccordionSummary-root': {
      opacity: 1,
    },
  },
}));

export const DocumentAccordionDetails = styled(AccordionDetails)(() => ({
  position: 'relative',
}));

export const DocumentAccordionItem = styled(Box, {
  shouldForwardProp: doNotForwardTheseProps('noBorder'),
})<{ noBorder?: boolean }>(({ theme, noBorder }) => ({
  padding: `${theme.spacing(1.75)} 0`,
  ':first-of-type': {
    paddingTop: 0,
  },
  ':last-of-type': {
    paddingBottom: 0,
  },
  ':not(:last-of-type)': {
    borderBottom: noBorder ? 'none' : `1px solid ${theme.palette.grey[300]}`,
  },
}));
